<div class="cls-rec">
    <div class="notifyRecommendation">
        <div *ngIf="this.notificationDetailMsg.notificationType != 'notification cycletime'">
            <p class="reason-tittle">{{this.notificationDetailMsg?.message}}</p>
        </div>
        <div *ngIf="this.notificationDetailMsg.notificationType == 'notification cycletime'">
            <p class="reason-tittle">{{this.notificationDetailMsg?.message}}</p>
            <p class="reason-tittle">Last trip time taken ({{this.notificationDetailMsg?.cycleTime}}) vs average cycle
                time ({{this.notificationDetailMsg?.avgCycleTime}})</p>
            <p class="reason-tittle">Current Source : {{this.notificationDetailMsg?.currentSource}}</p>
            <p class="reason-tittle">Current Destination : {{this.notificationDetailMsg?.currentDestination}}</p>
        </div>
        <p>{{this.notificationDetailMsg?.date | date :'dd/MM/yyyy h:mm:ss a' }}</p>
        <button class="edit-button" type="button" (click)="acknowledge(notificationDetailMsg.notificationId)">
            Acknowledge
        </button>
    </div>
</div>
